import * as React from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

interface IProps {
    className?: string;
    title: string;
}

interface IState {
    isOpen: boolean;
}

export class InfoModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: false
        };

        this.toggle = this.toggle.bind(this);
    }

    public render() {
        return (
            <React.Fragment>
                <div className={`info-button cursor-pointer ${this.props.className}`} onClick={this.toggle}></div>
                <Modal className="my-2 info-modal" isOpen={this.state.isOpen} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        <div className="d-flex">
                            <img className="d-block mr-3 mb-1" src="/img/Flow-info-selected.svg"/>
                            <div className="text-blue-2 font-weight-medium">{this.props.title}</div>
                        </div>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        {this.props.children}
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-primary btn-next" onClick={this.toggle}>Ok, I understand</button>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }

    private toggle(): void {
        this.setState((state: IState) => ({
            isOpen: !state.isOpen
        }));
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/InfoModal.tsx